module.exports = __webpack_public_path__ + "img/w矩形 83@3x.df5cf358.png";